export default __webpack_public_path__ + "static/media/ContactPassword.466471a8.svg";